<div class="tank-summary">
  <h4 class="text-center">Tank {{ tankNumber }}: {{ tankName }}</h4>

  <re-progress-bar
    [progress]="progress"
    [progress2]="progress2"
    [label]="label"
  />

  <h4 class="text-center">{{ fuelGrade }}</h4>
</div>
